import { call, put, takeEvery, select } from "redux-saga/effects";

import { getShareholders } from "../../../store/services/shareholder.service";

import {
  fetchShareholders,
  fetchShareholdersDropdown,
  fetchPhysicalShareholders,
  fetchPhysicalShareholdersDropdown,
  fetchElectronicShareholders,
  fetchElectronicShareholdersDropdown,
  fetchInactiveShareholders,
} from "./action";
import { toast } from "react-toastify";
import {
  WATCH_SHAREHOLDERS_DROPDOWN,
  WATCH_SHAREHOLDERS,
  // PHYSICAL
  WATCH_PHYSICAL_SHAREHOLDERS,
  WATCH_PHYSICAL_SHAREHOLDERS_DROPDOWN,
  // ELECTRONIC
  WATCH_ELECTRONIC_SHAREHOLDERS,
  WATCH_ELECTRONIC_SHAREHOLDERS_DROPDOWN,
  SHAREHOLDERS_BEGIN_LOADING,
  SHAREHOLDERS_END_LOADING,
  SHAREHOLDERS_BEGIN_DROPDOWN_LOADING,
  SHAREHOLDERS_END_DROPDOWN_LOADING,
  GET_INACTIVE_SHAREHOLDERS,
  INACTIVE_SHAREHOLDERS_END_LOADING,
  INACTIVE_SHAREHOLDERS_BEGIN_LOADING,
  WATCH_INACTIVE_SHAREHOLDERS,
} from "../../actionTypes";

const email = sessionStorage.getItem("email") || "";
const company_code = sessionStorage.getItem("company_code") || "";
const getAllShareholders = async (param = "") => {
  try {
    const response = await getShareholders(email, company_code, param);
    if (response.status === 200) return response;
    else return [];
  } catch (error) {
    !!error?.response?.data?.message
      ? toast.error(`${error?.response?.data?.message}`)
      : console.log("Shareholders Not Found");
    return [];
  }
};
function* fetchShareholdersAPI() {
  yield put({ type: SHAREHOLDERS_BEGIN_LOADING });
  const shareholders = yield call(getAllShareholders);
  yield put(fetchShareholders(shareholders.data.data));
  yield put({ type: SHAREHOLDERS_END_LOADING });
}
function* fetchInactiveShareholdersAPI() {
  yield put({ type: INACTIVE_SHAREHOLDERS_BEGIN_LOADING });
  const shareholders = yield call(getAllShareholders);
  yield put(fetchInactiveShareholders(shareholders.data.data));
  yield put({ type: INACTIVE_SHAREHOLDERS_END_LOADING });
}
function* fetchShareholdersDropdownAPI() {
  yield put({ type: SHAREHOLDERS_BEGIN_DROPDOWN_LOADING });
  const shareholders = yield call(getAllShareholders);
  let options = shareholders.data.data.map((item) => {
    let label = `${item.folio_number} (${item.shareholder_name}) `;
    return { label: label, value: item.folio_number };
  });
  yield put(fetchShareholdersDropdown(options));
  yield put({ type: SHAREHOLDERS_END_DROPDOWN_LOADING });
}

// PHYSICAL
function* fetchPhysicalShareholdersAPI() {
  const shareholders = yield call(getAllShareholders, "/active");
  yield put(
    fetchPhysicalShareholders(
      shareholders.data.data.filter((item) => item.cdc_key === "YES")
    )
  );
}
function* fetchPhysicalShareholdersDropdownAPI() {
  const shareholders = yield call(getAllShareholders);
  let options = shareholders.data.data
    .filter((item) => item.cdc_key === "NO")
    .map((item) => {
      let label = `${item.folio_number} (${item.shareholder_name}) `;
      return { label: label, value: item.folio_number };
    });
  yield put(fetchPhysicalShareholdersDropdown(options));
}

// ELECTRONIC
function* fetchElectronicShareholdersAPI() {
  const shareholders = yield call(getAllShareholders, "/active");
  yield put(
    fetchElectronicShareholders(
      shareholders.data.data.filter((item) => item.cdc_key === "YES")
    )
  );
}
function* fetchElectronicShareholdersDropdownAPI() {
  const shareholders = yield call(getAllShareholders);
  let options = shareholders.data.data
    .filter((item) => item.cdc_key === "YES")
    .map((item) => {
      let label = `${item.folio_number} (${item.shareholder_name}) `;
      return { label: label, value: item.folio_number };
    });
  yield put(fetchElectronicShareholdersDropdown(options));
}

// WATCHER
export function* watcherShareholders() {
  yield takeEvery(WATCH_SHAREHOLDERS, fetchShareholdersAPI);
  yield takeEvery(WATCH_SHAREHOLDERS_DROPDOWN, fetchShareholdersDropdownAPI);
  // INACTIVE
  yield takeEvery(WATCH_INACTIVE_SHAREHOLDERS, fetchInactiveShareholdersAPI);
  // PHYSICAL
  yield takeEvery(WATCH_PHYSICAL_SHAREHOLDERS, fetchPhysicalShareholdersAPI);
  yield takeEvery(
    WATCH_PHYSICAL_SHAREHOLDERS_DROPDOWN,
    fetchPhysicalShareholdersDropdownAPI
  );
  // ELECTRONIC
  yield takeEvery(
    WATCH_ELECTRONIC_SHAREHOLDERS,
    fetchElectronicShareholdersAPI
  );
  yield takeEvery(
    WATCH_ELECTRONIC_SHAREHOLDERS_DROPDOWN,
    fetchElectronicShareholdersDropdownAPI
  );
}
